<template>
    <div class="location-back">
        <!--环图片-->
        <div class="img-box">
            <div class="prop-up"></div>
            <img src="@/assets/img/circle.png" class="circle" alt="">
        </div>
        <!--题目-->
        <div class="subject">
            <div>{{ $t('locateQue1') }}</div>
        </div>
        <!--选项-->
        <div style="width:70px;margin:calc(0.073 * var(--body-height)) auto 0;">
            <el-radio-group v-model="position">
                <el-radio :label="$t('indoor')"></el-radio>
                <el-radio :label="$t('outdoor')"></el-radio>
            </el-radio-group>
        </div>
        <!--题目跳转-->
        <div class="subject-jump">
            <span @click="prevClick" class="prev-btn">{{ $t('preQues') }}</span>
            <el-button @click="nextClick" :disabled="countNumber != 0" style="width:160px;"
                type="primary">{{ $t('nextQues') }} <i class="icon-right"></i> ({{ countNumber }}s)
            </el-button>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "step1",
    data() {
        return {
            //位置，室内、室外
            position: '',
            timer: null,
            countNumber: 0,
            positionArr: [[this.$t('indoor'), '室内'], [this.$t('outdoor'), '室外']]
        }
    },
    computed: {
        ...mapGetters([
            'location1Answer',
            'aggressionFlag',
            'codeItem'
        ]),
    },
    watch: {
        '$route': {
            immediate: true, // 组件创建时立即触发
            handler(newVal, oldVal) {
                this.$store.commit('SET_ANSWER_PERCENT', 11 * 100 / 22)
            }
        }
    },
    mounted() {
        this.countdown()
        this.position = this.location1Answer
    },
    methods: {

        /**
         * 上一题
         */
        prevClick() {
            if (this.aggressionFlag == 0) { //攻击题
                this.$router.push({
                    path: '/aggression_weather/a',
                    query: {
                        id: 7
                    }
                })
            } else { //滑块题
                let arr = JSON.parse(localStorage.getItem('shuffledArray'))
                let len = arr.length
                this.$router.push({ path: '/mental/a', query: { id: arr[len - 1].id } })
            }
        },

        /**
         * 下一题
         */
        nextClick() {
            if (this.position == '') {
                this.$toast(this.$t('selectOne'));
                return;
            }
            //保存答案
            this.$store.commit('SET_LOCATION1_ANSWER', this.position)
            let codeField = this.positionArr.find(item => item[0] == this.position)[1]
            this.codeItem[0][1] = codeField
            if (this.position === this.$t('indoor')) {
                //清空其他分支答案
                this.$store.commit('SET_LOCATION3_ANSWER', ['', ''])
                this.$store.commit('SET_GARDEN_ANSWER', '')
                this.$store.commit('CLEAR_ENTER')
                this.$store.commit('SET_LEAVE1_ANSWER', '')
                this.$router.push('/location2')
            } else {
                this.$store.commit('SET_LOCATION2_ANSWER', ['', ''])
                this.$router.push('/location3')
            }
        },

        /**
         * 验证码倒计时
         */
        countdown() {
            let that = this;
            this.countNumber = 2;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(function () {
                if (that.countNumber === 0) {
                    clearInterval(this.timer);
                } else {
                    that.countNumber--;
                }
            }, 1000);
        }
    }
}
</script>

<style scoped lang="less">
.location-back {
    height: 100%;
}
</style>
